<template>
  <div class="donation-wildcard-recipient">
    <h2>Personalise</h2>

    <div class="wildcard">
      <div
        class="card"
        :style="'background-image: url(' + donation.wildcard.img + ')'"
      ></div>
    </div>

    <!-- Recipient Name -->
    <div class="wwf-field">
      <input
        name="dear"
        type="text"
        v-model="donation.wildcard.dear"
        v-validate="'required'"
        :class="{ error: errors.has('dear'), empty: !donation.wildcard.dear }"
        autocomplete="given-name"
      />
      <label for="dear">Dear</label>
    </div>

    <!-- Personal Message -->
    <div class="wwf-field">
      <textarea
        name="message"
        type="text"
        v-model="donation.wildcard.message"
        v-validate="'required'"
        :class="{
          error: errors.has('message'),
          empty: !donation.wildcard.message,
        }"
      ></textarea>
      <label for="message">Your personal message</label>
    </div>

    <h2>Recipient details</h2>

    <!-- Recipient Email -->
    <div class="wwf-field">
      <input
        id="recepientsemail"
        name="recepientsemail"
        type="email"
        v-model="donation.wildcard.email"
        v-validate="'required|email'"
        :class="{
          error: errors.has('recepientsemail'),
          empty: !donation.wildcard.email,
        }"
        autocomplete="email"
      />
      <label for="recepientsemail">Recipients email</label>
    </div>

    <!-- Send Date -->
    <div class="date-field">
      <datepicker
        :disabledDates="disabledFn"
        name="scheduledate"
        v-validate="'required'"
        :minimumView="'day'"
        :format="'dd/MM/yyyy'"
        :input-class="{ 'border-red': errors.has('scheduledate') }"
        v-model="donation.wildcard.scheduledate"
        :maximumView="'month'"
        :initialView="'day'"
        placeholder="Date to send"
      ></datepicker>
      <label for="scheduledate">
        <i class="far fa-calendar-alt"></i>
      </label>
    </div>

    <!-- Next button -->
    <button type="button" class="plain" v-on:click="next()">
      <span>Next</span>
      <span><i class="fas fa-arrow-right"></i></span>
    </button>
  </div>
</template>

<script>
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import AddressInput from "./AddressInput.vue";

import { mapState } from "vuex";

export default {
  name: "WildcardRecipient",
  components: {
    AddressInput,
    Datepicker,
  },

  data() {
    return {
      disabledFn: {
        customPredictor: (date) => {
          if (moment(new Date()).isAfter(date, "day")) {
            return true;
          }
        },
      },
    };
  },
  computed: {
    ...mapState({
      donation: (state) => state.donation.donation,
    }),
  },

  methods: {
    async next() {
      try {
        // Validate form
        await Promise.all([this.validate()]);

        // Commit the current step (Push to database)
        await this.commit();

        this.$emit("success");
      } catch (err) {
        console.error("Next - Error - ", err);
      }
    },
    validate() {
      return new Promise((resolve, reject) => {
        this.$validator
          .validateAll()
          .then((result) => {
            // Will return true if valid and false if not
            if (result) {
              resolve(result);
            } else {
              console.error("Recipient Details not valid - result", result);
              reject(result);
            }
          })
          .catch((err) => {
            console.error("Recipient Details Validation - Error - ", err);
            reject(err);
          });
      });
    },
    commit() {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("saveDonation")
          .then((response) => {
            resolve();
          })
          .catch((error) => {
            console.error("saveDonation1 error", error);
            reject(error);
          });
      });
    },
  },
};
</script>

<style scoped>
.date-field {
  position: relative;
}

.date-field i {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

.donation-wildcard-recipient textarea {
  resize: none;
}

.wildcard {
  position: relative;
  margin-bottom: 2rem;
  padding-top: 63%;
}

.card {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}
</style>


// WEBPACK FOOTER //
// WildcardRecipient.vue?7836477b